export { hasLocalOverrideFlag, LOCAL_FF_OVERRIDES } from './overrides'

export enum FEATURE_FLAG_TYPES {
  ACCOUNT_AUTOMATION_ENABLED = 'account-automation-enabled',
  ACCOUNT_CREATED_JOURNEY_ENABLED = 'account-created-journey-enabled',
  ADMIN_API_AUTH0_ENABLED = 'admin-api-auth0-enabled',
  ADMIN_API_AUTO_SYNC_CONDITIONS_ENABLED = 'admin-api-auto-sync-conditions-enabled',
  ADMIN_API_QUEUE = 'admin-api-queue',
  AI_DOCUMENT_EXTRACT_FETCH_SERVICES = 'ai-document-extract-fetch-services',
  AI_SCHEDULED_PRICING_ELIGIBILITY = 'ai-scheduled-pricing-eligibility',
  ALFIE_CERTIFIED_CREDIT_PULL = 'alfie-certified-credit-pull',
  ALFIE_CREATE_ACCOUNT_SAVE_FIX_ENABLED = 'alfie-create-account-save-fix-enabled',
  AMC_APPRAISAL_ENABLED = 'amc-appraisal-enabled',
  ANNALY_PAYOFF_ROUTING_ENABLED = 'annaly-payoff-routing-enabled',
  API_QUEUE = 'api-queue',
  APPLICATION_REVISION_SAVE_LOCK_ENABLED = 'application-revision-save-lock-enabled',
  APPRAISAL_VALUE_SLACK_NOTIFICATION_ENABLED = 'appraisal-value-slack-notification-enabled',
  APPS_FETCH_SERVICES = 'apps-fetch-services',
  ASSIGN_LO = 'assign-lo-top-of-funnel',
  ATTACHMENT_SERVICE_ENCOMPASS_AUTO_SYNC_ENABLED = 'attachment-service-encompass-auto-sync-enabled',
  AUS_OPEN_AI_ERROR_PROCESSING = 'aus-open-ai-error-processing',
  AUS_RECONCILIATION_ENCOMPASS_REMOVAL_ENABLED = 'aus-reconciliation-encompass-removal-enabled',
  AUS_WATERFALL_ENABLED = 'aus-waterfall-enabled',
  AUTH0_FETCH_SERVICES = 'auth0-fetch-services',
  AUTH0_WEBHOOK_PROCESSOR_LAMBDA_ENABLED = 'auth0-webhook-processor-lambda-enabled',
  AUTH0_WEBHOOK_PROCESSOR_LOGGING_ENABLED = 'auth0-webhook-processor-logging-enabled',
  AUTH_RECHECK_ON_PAGE_TRANSITION_ENABLED = 'auth-recheck-on-page-transition-enabled',
  AUTO_ASSIGN_INBOUND_CALLS_LOS = 'auto-assign-inbound-calls-los',
  AUTO_ASSIGN_LOAN_OFFICER_ENABLED = 'auto-assign-loan-officer-enabled',
  AUTO_CONDITION_LINK_ENABLED = 'auto-condition-link-enabled',
  AUTO_CONFIRM_LOCK_REQUEST_ENABLED = 'auto-confirm-lock-request-enabled',
  AUTO_PROMOTE_FOR_ALL_LOANS = 'auto-promote-for-all-loans',
  AUTO_CONFIRM_COC_LOCK_REQUEST_ENABLED = 'auto-confirm-coc-lock-request-enabled',
  AUTO_ICE_BOX_LAMBDA_ENABLED = 'auto-ice-box-lambda-enabled',
  AUTO_SYNC_CONDITIONS_ENABLED = 'auto-sync-conditions-enabled',
  AUTO_TRIGGER_VEPA_VALIDATIONS = 'auto-trigger-vepa-validations',
  AUTOCONTACT_QUEUE_LAMBDA_ENABLED = 'autocontact-queue-lambda-enabled',
  AUTOCONTACT_QUEUE_LOGGING_ENABLED = 'autocontact-queue-logging-enabled',
  AUTOMATED_FOLLOWUP_TEXT_MESSAGES = 'automated-followup-text-messages',
  AUTOMATED_TEXT_MESSAGES_SKIP_TIME_ZONE_CHECK = 'automated-text-messages-skip-time-zone-check',
  BOOMERANG_EXCLUDED_LOS = 'boomerang-excluded-los',
  BOTSPLASH_ENABLED = 'botsplash-enabled',
  BOTSPLASH_STRICT_AGENT_VALIDATION = 'botsplash-strict-agent-validation',
  BOTSPLASH_SHARED_VISITORS_START_AT = 'botsplash-shared-visitors-start-at',
  BOTSPLASH_ROUTING_MODE = 'botsplash-routing-mode',
  BOTSPLASH_CANARY_PHONES = 'botsplash-canary-phones',
  BOTSPLASH_PROVISIONING_PAUSED = 'botsplash-provisioning-paused',
  BOTSPLASH_LISTENER_DIRECTORY_AGENT_LOS = 'botsplash-listener-directory-agent-los',
  BOTSPLASH_SMS_INGESTION_ENABLED = 'botsplash-sms-ingestion-enabled',
  BP_ITERABLE_V1 = 'bp-iterable-v1',
  BUILDER_LOAN_TEMPLATE_ENABLED = 'builder-loan-template-enabled',
  CALL_TRANSCRIPTION_BACKFILL_ENABLED = 'call-transcription-backfill-enabled',
  CIC_SLACK_NOTIFICATION_ENABLED = 'cic-slack-notification-enabled',
  COMMUNICATION_LOG_RESOLVER_BYPASSED = 'communication-log-resolver-bypassed',
  CONDITION_NOTIFICATION_ENABLED = 'condition-notification-enabled',
  CREATE_VEPA_LETTER_REVISION = 'create-vepa-letter-revision',
  DATA_EXPLORER_SCHEDULE_SLACK_NOTIFY_ENABLED = 'data-explorer-schedule-slack-notify-enabled',
  DATA_EXPLORER_SHARE_TO_SLACK_ENABLED = 'data-explorer-share-to-slack-enabled',
  DEBUG_MQ_REQUEST = 'debug-mq-request',
  DEBUG_NTL_QUALIFICATION = 'debug-ntl-qualification',
  DEFAULT_QUESTIONNAIRE_SLUG = 'default-questionnaire-slug',
  DEFAULT_QUESTIONNAIRE_SLUG_PURCHASE = 'default-questionnaire-slug-purchase',
  DISABLE_LENDER_CREDIT_FEE = 'disable-lender-credit-fee',
  DOCUMENT_PIPELINE_CONCURRENCY_CAP_ENABLED = 'document-pipeline-concurrency-cap-enabled',
  DOCUMENT_PIPELINE_FETCH_SERVICES = 'document-pipeline-fetch-services',
  DOCUMENT_UPLOAD_FETCH_SERVICES = 'document-upload-fetch-services',
  DOCUMENT_CLASSIFICATION_ENABLED = 'document-classification-enabled',
  DOCUMENT_CATEGORIZATION_ENABLED = 'document-categorization-enabled',
  DOCUMENT_CONDITION_MATCH_PRE_FILTER_ENABLED = 'document-condition-match-pre-filter-enabled',
  ENABLE_UNASSIGNED_ATTACHMENT_CONDITION_MATCHING = 'enable-unassigned-attachment-condition-matching',
  DOCUMENT_NAMING_SHADOW_ENABLED = 'document-naming-shadow-enabled',
  DOCUMENT_WORKSTATION_PDF_SPLIT_ENABLED = 'document-workstation-pdf-split-enabled',
  DOCUSIGN_FETCH_SERVICES = 'docusign-fetch-services',
  DOCUTECH_DISCLOSURE_EMAILS_ENABLED = 'docutech-disclosure-emails-enabled',
  DOCUTECH_WEBHOOK_PROCESSOR_LAMBDA_ENABLED = 'docutech-webhook-processor-lambda-enabled',
  DYNAMIC_PHONE_PILL_ENABLED = 'dynamic-phone-pill-enabled',
  ELLO_BLOCK_UPDATE_ENABLED = 'ello-block-update-enabled',
  ELLO_SYNC_CREATE_LOAN_ENABLED = 'ello-sync-create-loan-enabled',
  ELLO_SYNC_ENCOMPASS_PUSH_TO_PIPELINE = 'ello-sync-encompass-push-to-pipeline',
  ELLO_SYNC_LOAN_ENABLED = 'ello-sync-loan-enabled',
  ELLO_SYNC_LOGGING_ENABLED = 'ello-sync-logging-enabled',
  ELLO_SYNC_PROCESSOR_LAMBDA_ENABLED = 'ello-sync-processor-lambda-enabled',
  ELLO_SYNC_SEND_LOAN_AUDIT_SLACK_ENABLED = 'ello-sync-send-loan-audit-slack-enabled',
  ELLO_SYNC_UPDATE_NEW_NOTES = 'ello-sync-update-new-notes',
  EMAIL_BACKFILL_DB_DEDUPE_LOGGING_ENABLED = 'email-backfill-db-dedupe-logging-enabled',
  EMAIL_LOGGING_ENABLED = 'email-logging-enabled',
  EMAIL_PROCESSOR_LAMBDA_ENABLED = 'email-processor-lambda-enabled',
  EMAIL_VALIDATOR_LAMBDA_ENABLED = 'email-validator-lambda-enabled',
  EMAIL_VALIDATOR_LOGGING_ENABLED = 'email-validator-logging-enabled',
  ENABLE_AI_CALL_NOTES = 'enable-ai-call-notes',
  ENABLE_AI_CALL_SCORING = 'enable-ai-call-scoring',
  ENABLE_CALL_OPPORTUNITY_EVALUATION = 'enable-call-opportunity-evaluation',
  ENABLE_AI_CALLBACK_SCHEDULE = 'enable-ai-callback-schedule',
  ENABLE_AI_CALL_SCHEDULER_LANGFUSE_TRACING = 'enable-ai-call-scheduler-langfuse-tracing',
  ENABLE_AI_CONDITION_CLEARING = 'enable-ai-condition-clearing',
  ENABLE_ALFIE_CREDIT_ORDER = 'enable-alfie-credit-order',
  ENABLE_ALFIE_PROCESS_LIABILITIES_AND_CREDIT = 'enable-alfie-process-liabilities-and-credit',
  ENABLE_APPLICATION_STATUS_DEDUPE = 'enable-application-status-dedupe',
  ENABLE_AUS_ANALYSIS = 'enable-aus-analysis',
  ENABLE_ENCOMPASS_FINDINGS_AUS_REPORT_JOB = 'enable-encompass-findings-aus-report-job',
  ENABLE_AUS_TABLE = 'enable-aus-table',
  ENABLE_AUTO_CONDITION_REVIEW = 'enable-auto-condition-review',
  ENABLE_BP_APPLICATION_SWITCHER = 'enable-bp-application-switcher',
  ENABLE_BP_NEWSFEED_REALTOR_QUESTION = 'enable-bp-newsfeed-realtor-question',
  ENABLE_BP_OVERVIEW_PAGE = 'enable-bp-overview-page',
  ENABLE_BP_PAYMENT_SERVICER_WIDGET = 'enable-bp-payment-servicer-widget',
  ENABLE_BP_RATES_PAGE = 'enable-bp-rates-page',
  ENABLE_BP_RATES_ESTIMATE_DOWNLOAD = 'enable-bp-rates-estimate-download',
  BP_RATES_PAGE_ALLOWLIST = 'bp-rates-page-allowlist',
  ENABLE_BP_REALTOR_SEND_EMAIL = 'enable-bp-realtor-send-email',
  ENABLE_BP_REGGORA_PAGE = 'enable-bp-reggora-page',
  ENABLE_BP_DOCUTECH_IFRAME = 'enable-bp-docutech-iframe',
  ENABLE_BP_DOC_UPLOAD_FEEDBACK = 'enable-bp-doc-upload-feedback',
  ENABLE_BROAD_BP_DOC_UPLOAD_FEEDBACK = 'enable-broad-bp-doc-upload-feedback',
  ENABLE_BP_HELOC_CTA = 'enable-bp-heloc-cta',
  ENABLE_BP_TASKS_V2 = 'enable-bp-tasks-v2',
  ENABLE_BP_SIGNED_DISCLOSURE_PACKETS = 'enable-bp-signed-disclosure-packets',
  ENABLE_CERTIFIED_CREDIT_DEBUG_LOGGING = 'enable-certified-credit-debug-logging',
  ENABLE_COC_MODIFICATIONS = 'enable-coc-modifications',
  ENABLE_COC_LOCK_REQUEST_AI_SUMMARY = 'enable-coc-lock-request-ai-summary',
  ENABLE_CONDITION_FULFILLMENT_CHECK = 'enable-condition-fulfillment-check',
  ENABLE_SEMANTIC_SELECTION_IN_CONDITION_FULFILLMENT = 'enable-semantic-selection-in-condition-fulfillment',
  ENABLE_GUIDELINES_CONTEXT_PROVIDER = 'enable-guidelines-context-provider',
  ENABLE_DOCS_UPLOADED_STATUS = 'enable-docs-uploaded-status',
  ENABLE_CREDIT_REPORT_MERGE_LIABILITIES = 'enable-credit-report-merge-liabilities',
  ENABLE_CREDIT_REPORT_VGS_ACCOUNT_ALIAS = 'enable-credit-report-vgs-account-alias',
  ENABLE_DIRECT_ENCOMPASS_LOCK_REQUEST = 'enable-direct-encompass-lock-request',
  ENABLE_DOCUMENT_CONTENT_SEARCH = 'enable-document-content-search',
  ENABLE_DOCUMENT_STREAM_UPLOADS = 'enable-document-stream-uploads',
  ENABLE_DOCUMENT_SCANNING = 'enable-document-scanning',
  ENABLE_DU_PLUS_ELLO_MODAL = 'enable-du-plus-ello-modal',
  ENABLE_DU_UPDATED_PDF = 'enable-du-updated-pdf',
  ENABLE_DUPLICATION_SERVICE_LOAN_OFFICER_ASSIGNMENT = 'enable-duplication-service-loan-officer-assignment',
  ENABLE_EARLY_CHECK_JOBS = 'enable-early-check-jobs',
  ENABLE_ENCOMPASS_COMPLIANCE_REVIEW = 'enable-encompass-compliance-review',
  ENABLE_ENCOMPASS_PRICING_EXCEPTION = 'enable-encompass-pricing-exception',
  ENABLE_ENCOMPASS_UPDATE_LOAN_OBJECT = 'enable-encompass-update-loan-object',
  ENABLE_FANNIE_MAE_DIRECT_PRODUCTION_CREDENTIALS = 'enable-fannie-mae-direct-production-credentials',
  ENABLE_FANNIE_TITLE_ACCEPTANCE = 'enable-fannie-title-acceptance',
  ENABLE_FIGURE_STATUS_CHANGE_DMS = 'enable-figure-status-change-dms',
  ENABLE_FILL_MUTATION_LOAN_PURPOSE_DEFAULT = 'enable-fill-mutation-loan-purpose-default',
  ENABLE_FLOAT_LOCK_REQUEST_AI_ERRORS = 'enable-float-lock-request-ai-errors',
  ENABLE_ITERABLE_WEBHOOK_LOGGING = 'enable-iterable-webhook-logging',
  ENABLE_LANGFUSE_TRACING = 'enable-langfuse-tracing',
  ENABLE_PLAID_AI_INCOME_ANALYSIS = 'enable-plaid-ai-income-analysis',
  ENABLE_PLAID_CRA = 'enable-plaid-cra',
  ENABLE_LEAD_ASSIGNMENT_TIMEZONE_CHECK = 'enable-lead-assignment-timezone-check',
  ENABLE_LEAD_ROUTING_TIMEZONE_CHECK = 'enable-lead-routing-timezone-check',
  ENABLE_LO_HEADSHOT_UPLOAD = 'enable-lo-headshot-upload',
  ENABLE_LO_BORROWER_VIEW = 'enable-lo-borrower-view',
  ENABLE_LO_SSN_UPLOAD_NOTIFICATION = 'enable-lo-ssn-upload-notification',
  ENABLE_LO_TRID_TRIPPED_NOTIFICATION = 'enable-lo-trid-tripped-notification',
  ENABLE_LOAN_MATCH_REFI_OFFER_EVENT = 'enable-loan-match-refi-offer-event',
  ENABLE_LOANCARE_DATA_MATCH_ROUTING = 'enable-loancare-data-match-routing',
  ENABLE_LOCK_REQUEST_COMMITTING = 'enable-lock-request-committing',
  ENABLE_LOCK_REQUEST_PRICING_API = 'enable-lock-request-pricing-api',
  ENABLE_LOCK_REQUEST_SELL_SIDE_UPDATING = 'enable-lock-request-sell-side-updating',
  ENABLE_MILITARY_FIELD_SYNC = 'enable-military-field-sync',
  ENABLE_AUTO_CONDITION_PROMOTION = 'enable-auto-condition-promotion',
  ENABLE_CONDITION_FULFILLMENT_SWEEP = 'enable-condition-fulfillment-sweep',
  ENABLE_BROAD_AUS_AUTO_CONDITIONING = 'enable-broad-aus-auto-conditioning',
  ENABLE_AUS_BATCH_ENCOMPASS_SYNC = 'enable-aus-batch-encompass-sync',
  ENABLE_MQ_SPECIAL_RATES_FILTERING = 'enable-mq-special-rates-filtering',
  ENABLE_PROCESSOR_TOP_CARDS = 'enable-processor-top-cards',
  ENABLE_PROCESSOR_PIPELINE_ACTION_REQUIRED = 'enable-processor-pipeline-action-required',
  ENABLE_PURCHASE_LEAD_ASSIGNMENT = 'enable-purchase-lead-assignment',
  ENABLE_REAPP_CONDITIONS_DUPLICATION = 'enable-reapp-conditions-duplication',
  ENABLE_REAPP_DECS_DEMS_TASK = 'enable-reapp-decs-dems-task',
  ENABLE_REFI_PRICING_GATE = 'enable-refi-pricing-gate',
  ENABLE_REFINANCE_LEAD_ASSIGNMENT = 'enable-refinance-lead-assignment',
  ENABLE_REGGORA_APPRAISAL_ORDER_EMAIL = 'enable-reggora-appraisal-order-email',
  ENABLE_REGGORA_PROPERTY_INSPECTION_WAIVER_CHECK = 'enable-reggora-property-inspection-waiver-check',
  RH_CONCIERGE_ENABLED_UUIDS = 'rh-concierge-enabled-uuids',
  RH_LEADS_PROD_TO_QA_ROUTING_UUIDS = 'rh-leads-prod-to-qa-routing-uuids',
  RH_HELOC_FIGURE_DEEPLINK_ENABLED = 'rh-heloc-figure-deeplink-enabled',
  ENABLE_RH_LEADS_LOGGING = 'enable-rh-leads-logging',
  ENABLE_RINGCENTRAL_WEBHOOK_CONTACT_LOGGING = 'enable-ringcentral-webhook-contact-logging',
  ENABLE_ROBINHOOD_NOTIFICATION_EVENT = 'enable-robinhood-notification-event',
  ENABLE_SEND_LEADS_SQUEEZE = 'enable-send-leads-squeeze',
  ENABLE_SENDGRID_WEBHOOK_LOGGING = 'enable-sendgrid-webhook-logging',
  ENABLE_SERVICER_DATA_IMPORT = 'enable-servicer-data-import',
  ENABLE_SERVICING_LOAN_MATCH_REFI_OFFER_EVENT = 'enable-servicing-loan-match-refi-offer-event',
  ENABLE_SIMPLE_V1 = 'enable-simple-v-1',
  ENABLE_BANKRATE_SIMPLE_V2_ROUTING = 'enable-bankrate-simple-v2-routing',
  ENABLE_SIMPLE_V2_PILOT_ASSIGNMENT = 'enable-simple-v2-pilot-assignment',
  ENABLE_SIMPLE_V2_FANNIE_VARIANT = 'enable-simple-v2-fannie-variant',
  ENABLE_SIMPLE_V2_ASSIGN_AT_INTAKE = 'simple-v2-assign-at-intake',
  ENABLE_SPECIAL_ALFIE_LINK_HANDLING = 'enable-special-alfie-link-handling',
  ENABLE_STORYBLOK_FOLDERS = 'enable-storyblok-folders',
  ENABLE_TRANSUNION_DEBUG_LOGGING = 'enable-transunion-debug-logging',
  ENABLE_TU_MORTGAGE_RATE_ESTIMATES = 'enable-tu-mortgage-rate-estimates',
  ENABLE_UPDATE_TRACKING_DATA = 'enable-update-tracking-data',
  ENABLE_UW_HANDOFF_GENERATION = 'enable-uw-handoff-generation',
  ENABLE_VEPA_AUTO_SSN_TASK = 'enable-vepa-auto-ssn-task',
  ENABLE_VEPA_AUTO_SOFT_PULL_ON_SSN = 'enable-vepa-auto-soft-pull-on-ssn',
  ENABLED_EVENTING_EVENTS = 'enabled-eventing-events',
  ENCOMPASS_ATTACHMENT_DOWNLOAD_ENABLED = 'encompass-attachment-download-enabled',
  ENCOMPASS_ATTACHMENT_LINK_ENABLED = 'encompass-attachment-link-enabled',
  ENCOMPASS_ATTACHMENT_RECONCILIATION_ENABLED = 'encompass-attachment-reconciliation-enabled',
  ENCOMPASS_AUTO_CREATE_PRELIM_CONDITION_ON_DOCUMENT_SYNC_ENABLED = 'encompass-auto-create-prelim-condition-on-document-sync-enabled',
  ENCOMPASS_AUTO_LOCK_REQUEST_ENABLED = 'encompass-auto-lock-request-enabled',
  ENCOMPASS_CONDITION_REMOVAL_CORRECTION_ENABLED = 'encompass-condition-removal-correction-enabled',
  ENCOMPASS_CONDITION_SYNC_ENABLED = 'encompass-condition-sync-enabled',
  ENCOMPASS_CONDITION_SYNC_HACK_ENABLED = 'encompass-condition-sync-hack-enabled',
  ENCOMPASS_DISCLOSURE_TASKS_ENABLED = 'encompass-disclosure-tasks-enabled',
  ENCOMPASS_ENABLE_PROCESSOR_SYNC = 'encompass-enable-processor-sync',
  ENCOMPASS_FETCH_SERVICES = 'encompass-fetch-services',
  ENCOMPASS_MILESTONE_COMMENT_SYNC_ENABLED = 'encompass-milestone-comment-sync-enabled',
  ENCOMPASS_PENDING_SYNC_PROTECTION_ENABLED = 'encompass-pending-sync-protection-enabled',
  ENCOMPASS_REMOVAL_VERIFICATION_ENABLED = 'encompass-removal-verification-enabled',
  ENCOMPASS_PRICING_INPUTS_ENABLED = 'encompass-pricing-inputs-enabled',
  ENCOMPASS_PRICING_SCENARIO_FEES_IN_UPDATE_ENABLED = 'encompass-pricing-scenario-fees-in-update-enabled',
  ENCOMPASS_REPORTING_RESYNC_MAX_RECORD_COUNT = 'encompass-reporting-resync-max-record-count',
  ENCOMPASS_RESOURCE_LOCK_BLOCK_VEPA_UPDATES = 'encompass-resource-lock-block-vepa-updates',
  ENCOMPASS_RESOURCE_LOCK_PLUGIN_ENABLED = 'encompass-resource-lock-plugin-enabled',
  ENCOMPASS_SDK_ENABLED = 'encompass-sdk-enabled',
  ENCOMPASS_TEMPLATE_FOLDERS_ENABLED = 'encompass-template-folders-enabled',
  ENCOMPASS_TEMPLATE_UPDATE_ENABLED = 'encompass-template-update-enabled',
  ENCOMPASS_UNDERWRITING_CONDITION_SYNC_ENABLED = 'encompass-underwriting-condition-sync-enabled',
  ENCOMPASS_UNDERWRITING_CONDITION_SYNC_INTERNAL = 'encompass-underwriting-condition-sync-internal',
  ENCOMPASS_WEBHOOK_LOGGING_ENABLED = 'encompass-webhook-logging-enabled',
  ENCOMPASS_WEBHOOK_PROCESSOR_LAMBDA_ENABLED = 'encompass-webhook-processor-lambda-enabled',
  ENHANCED_AUTO_TEXT_TIMING = 'enhanced-auto-text-timing',
  ESSENT_QUOTING_ENABLED = 'essent-quoting-enabled',
  EVENT_MODEL_LOGGING_ENABLED = 'event-model-logging-enabled',
  EVENT_MODEL_PROCESSOR_LAMBDA_ENABLED = 'event-model-processor-lambda-enabled',
  EXPOSE_MORTGAGE_RATE_ESTIMATES = 'expose-mortgage-rate-estimates',
  EXTERNAL_SYNC_TRACKING_ENABLED = 'external-sync-tracking-enabled',
  FANNIE_MAE_AUTOMATION_FLOW_ROLLOUT_PERCENTAGE = 'fannie-mae-automation-flow-rollout-percentage',
  FANNIE_MAE_AUTOMATION_PILOT_FORCE_CO_DEV_ENVIRONMENT = 'fannie-mae-automation-pilot-force-co-dev-environment',
  FANNIE_MAE_CREDIT_REPORT_PARSING = 'fannie-mae-credit-report-parsing',
  FANNIE_MAE_DIRECT_AUS = 'fannie-mae-direct-aus',
  FANNIE_MAE_DIRECT_CREDIT_REPORT_REQUEST_TYPE = 'fannie-mae-direct-credit-report-request-type',
  FANNIE_MAE_DIRECT_FAILURE_DIAGNOSTICS = 'fannie-mae-direct-failure-diagnostics',
  FANNIE_MAE_DIRECT_JSON_RESPONSE = 'fannie-mae-direct-json-response',
  FANNIE_MAE_DIRECT_LOGGING = 'fannie-mae-direct-logging',
  FANNIE_MAE_DIRECT_TESTING_TABLES = 'fannie-mae-direct-testing-tables',
  FANNIE_MAE_DIRECT_VA_PD_CONTACT = 'fannie-mae-direct-va-pd-contact',
  FANNIE_MAE_FETCH_SERVICES = 'fannie-mae-fetch-services',
  FANNIE_MAE_PLAID_ENABLED = 'fannie-mae-plaid-enabled',
  FANNIE_MAE_SOFT_CREDIT_PULL = 'fannie-mae-soft-credit-pull',
  FANNIE_MAE_SOFT_CREDIT_PULL_ALLOWLIST = 'fannie-mae-soft-credit-pull-allowlist',
  FANNIE_MAE_TEST_CREDIT_SERVICE = 'fannie-mae-test-credit-service',
  FINICITY_FETCH_SERVICES = 'finicity-fetch-services',
  FIVE9_FETCH_SERVICES = 'five9-fetch-services',
  FIVE9_SMS_ENABLED = 'five9-sms-enabled',
  FIVE9_CONTACTS_ENABLED = 'five9-contacts-enabled',
  GEMINI_FULFILLMENT_ENABLED = 'gemini-fulfillment-enabled',
  GENERATE_PRELIMINARY_CONDITIONS = 'generate-preliminary-conditions',
  GEMINI_OCR_ENABLED = 'gemini-ocr-enabled',
  HOME_EQUITY_FETCH_SERVICES = 'home-equity-fetch-services',
  HOME_EQUITY_IGNORE_EXISTING_USER_EMAIL = 'home-equity-ignore-existing-user-email',
  HOME_EQUITY_NO_OFFER_REASONS = 'home-equity-no-offer-reasons',
  HOME_EQUITY_SKIP_EXISTING_ASSIGNMENT_CHECK = 'home-equity-skip-existing-assignment-check',
  HOME_EQUITY_SKIP_FIGURE_NON_RH = 'home-equity-skip-figure-non-rh',
  ICE_ENABLED_STATES = 'ice-enabled-states',
  LAMBDAS_FETCH_SERVICES = 'lambdas-fetch-services',
  LEAD_ASSIGNMENT_DIRECT_MESSAGE = 'lead-assignment-direct-message',
  LEAD_ROUTING_CHECK_ACTIVE_CALLS = 'lead-routing-check-active-calls',
  LEAD_ROUTING_CHECK_ASSIGNMENT_LIMIT = 'lead-routing-check-assignment-limit',
  LEAD_ROUTING_CHECK_CLOCKED_IN = 'lead-routing-check-clocked-in',
  LEAD_ROUTING_DISABLED_SOURCES = 'lead-routing-disabled-sources',
  LEAD_ROUTING_GROUP_QUEUE_DELAY_SECONDS = 'lead-routing-group-queue-delay-seconds',
  LEAD_ROUTING_GROUP_QUEUE_ENABLED = 'lead-routing-group-queue-enabled',
  LEAD_ROUTING_GROUP_QUEUE_ORDER = 'lead-routing-group-queue-order',
  LEAD_ROUTING_HARD_ASSIGNMENT_LIMIT_CHECK = 'lead-routing-hard-assignment-limit-check',
  LEAD_ROUTING_HARD_IS_PURCHASE_CHECK = 'lead-routing-hard-is-purchase-check',
  LEAD_ROUTING_HARD_IS_REFINANCE_CHECK = 'lead-routing-hard-is-refinance-check',
  LEAD_ROUTING_LOGGING_ENABLED = 'lead-routing-logging-enabled',
  LEAD_ROUTING_PROCESSOR_LAMBDA_MODE = 'lead-routing-processor-lambda-mode',
  LEAD_ROUTING_RECIRCULATION_MAX_SIGNAL = 'lead-routing-recirculation-max-signal',
  LEAD_ROUTING_RECIRCULATION_MODE = 'lead-routing-recirculation-mode',
  LEAD_ROUTING_RECIRCULATION_SOURCES = 'lead-routing-recirculation-sources',
  LEAD_ROUTING_QUEUE_ENABLED_HOME_EQUITY = 'lead-routing-queue-enabled-home-equity',
  LEAD_ROUTING_HOME_EQUITY_SQUEEZE_FALLBACK_ENABLED = 'lead-routing-home-equity-squeeze-fallback-enabled',
  LEAD_SCORING_PREDICTION_CACHE_ENABLED = 'lead-scoring-prediction-cache-enabled',
  LEAD_SCORING_QUEUE_SCORING_ENABLED = 'lead-scoring-queue-scoring-enabled',
  LEAD_SCORING_RESCORE_JOB_ENABLED = 'lead-scoring-rescore-job-enabled',
  LEAD_SCORING_ROBINHOOD_ROUTING_ENABLED = 'lead-scoring-robinhood-routing-enabled',
  LEAD_SCORING_ROUTING_ENABLED = 'lead-scoring-routing-enabled',
  LEAD_SCORING_ROUTING_PERCENT = 'lead-scoring-routing-percent',
  LEAD_SCORING_SCORE_ALL_POLICIES_ENABLED = 'lead-scoring-score-all-policies-enabled',
  LENDER_ENABLED_LOS = 'lender-enabled-los',
  LENDER_ENABLED_STATES = 'lender-enabled-states',
  LO_ASSIGNMENT_USE_WEEKLY_COUNT = 'lo-assignment-use-weekly-count',
  LO_LENDER_LICENSE_ENABLED = 'lo-lender-license-enabled',
  LOAN_ASSISTANT_CHAT_FETCH_SERVICES = 'loan-assistant-chat-fetch-services',
  LOAN_MATCH_SILK_FEES_ENABLED = 'loan-match-silk-fees-enabled',
  LOAN_OFFICER_APPLICATION_REMINDER_REMINDERS_ENABLED = 'loan-officer-application-reminder-reminders-enabled',
  LOAN_OFFICER_REMINDERS_ENABLED = 'loan-officer-reminders-enabled',
  LOAN_OFFICER_REMINDERS_EXCLUDED_USERNAMES = 'loan-officer-reminders-excluded-usernames',
  LOAN_PROGRAM_RULES_ENABLED = 'loan-program-rules-enabled',
  LOG_FEE_REQUEST_ENABLED = 'log-fee-request-enabled',
  NEW_ZIP_LEAD_PUSH_ENABLED = 'new-zip-lead-push-enabled',
  NTL_DISABLED_QUESTION_SETS = 'ntl-disabled-question-sets',
  PARTNER_API_REDIRECT_URL_ALLOWLIST = 'partner-api-redirect-url-allowlist',
  PARTNERS_FETCH_SERVICES = 'partners-fetch-services',
  PASSWORDLESS_WORKFLOW = 'passwordless-workflow',
  PATRICK_APPROVAL_SLACK_NOTIFY_ENABLED = 'patrick-approval-slack-notify-enabled',
  PATRICK_BROWSER_REPLAY_ENABLED = 'patrick-browser-replay-enabled',
  PATRICK_RUN_SLACK_NOTIFY_ENABLED = 'patrick-run-slack-notify-enabled',
  PATRICK_SCHEDULES_ENABLED = 'patrick-schedules-enabled',
  PATRICK_TRIGGERS_ENABLED = 'patrick-triggers-enabled',
  PATRICK_WORKSPACE_ATHENA_ONLY_ENABLED = 'patrick-workspace-athena-only-enabled',
  PHOENIX_ONLY_ENABLED = 'phoenix-only-enabled',
  PHONE_FLOW_ENABLED = 'phone-flow-enabled',
  PRELIMINARY_CONDITION_SYNC_ENABLED = 'preliminary-condition-sync-enabled',
  PROCESSOR_CONDITION_UPLOAD_SLACK_V1 = 'processor-condition-upload-slack-v1',
  RATE_SHEET_CREATOR_GLOBAL_CONFIG = 'rate-sheet-creator-global-config',
  RING_CENTRAL_CONTACTS = 'ring-central-contacts-enabled',
  RING_CENTRAL_FETCH_SERVICES = 'ring-central-fetch-services',
  ROBINHOOD_ONLY_ENABLED = 'robinhood-only-enabled',
  ROUTE_DU_TO_ENCOMPASS_AFTER_REGISTRATION = 'route-du-to-encompass-after-registration',
  S3_NOTIFICATION_PROCESSOR_LAMBDA_ENABLED = 's3-notification-processor-lambda-enabled',
  S3_NOTIFICATION_PROCESSOR_LOGGING_ENABLED = 's3-notification-processor-logging-enabled',
  SAGE_CLOSING_CREDIT_OFFER_AMOUNT = 'sage-closing-credit-offer-amount',
  PATRICK_SLACK_NOTIFICATIONS_ENABLED = 'patrick-slack-notifications-enabled',
  SCHEDULE_SLACK_NOTIFY_ENABLED = 'schedule-slack-notify-enabled',
  SERVICER_LEAD_DEFER_ROUTING_ENABLED = 'servicer-lead-defer-routing-enabled',
  SERVICES_FETCH_SERVICES = 'services-fetch-services',
  SHOW_BORROWER_PORTAL_V2 = 'show-borrower-portal-v2',
  SHOW_COVERAGE_NAVIGATION_OPTION = 'show-coverage-navigation-option',
  SHOW_PRICING_STEP_LEFT_RAIL = 'show-pricing-step-left-rail',
  SIDEBAR_ENABLED = 'sidebar-enabled',
  SILK_CACHE_ENABLED = 'silk-cache-enabled',
  SKIP_AVM_REQUEST = 'skip-avm-request',
  SKIP_BORROWER_PORTAL = 'skip-borrower-portal',
  SNS_APPLICATION_PUBLISH = 'sns-application-publish',
  SOFT_CREDIT_REPORT_PROVIDER = 'soft-credit-report-provider',
  SUSPENSION_NOTIFICATIONS_ENABLED = 'suspension-notifications-enabled',
  TEST_ICE_DEFAULTS = 'test-ice-defaults',
  TESTING_INTERNAL_AUS = 'testing-internal-aus',
  TOGGLE_NEW_DEBT_TO_INCOME_CALCULATION = 'toggle-new-debt-to-income-calculation',
  TRID_COUNTDOWN_REMINDERS_ENABLED = 'trid-countdown-reminders-enabled',
  TRID_SCHEDULED_ENCOMPASS_PUSH = 'trid-scheduled-encompass-push',
  UNISOURCE_ENABLED = 'unisource-enabled',
  UNISOURCE_OVERRIDE = 'unisource-override',
  UPDATE_ENCOMPASS_LOCK_DATA_ENABLED = 'update-encompass-lock-data-enabled',
  UPDATE_ENCOMPASS_MILESTONES = 'update-encompass-milestones',
  USE_AMAZON_TRANSCRIBE = 'use-amazon-transcribe',
  USE_GOOGLE_TIME_ZONE_API = 'use-google-time-zone-api',
  USE_INTERNAL_APR_CALCULATION = 'use-internal-apr-calculation',
  USE_NEW_MERGE_CREDIT_LIABILITIES_PROCESS = 'use-new-merge-credit-liabilities-process',
  USE_WORKER_RH_TOKEN_DECRYPTION = 'use-worker-rh-token-decryption',
  VEPA_ALERT_SHADOW_TEST = 'vepa-alert-shadow-test',
  VEPA_NOTIFICATION_ENABLED_LOS = 'vepa-notification-enabled-los',
}

export type ffKey = keyof typeof FEATURE_FLAG_TYPES
export type ffPayload = boolean | string | string[] | object | number
export type DefaultFeatureFlags = Record<FEATURE_FLAG_TYPES, ffPayload>

export const DEFAULT_FEATURE_FLAGS: DefaultFeatureFlags = {
  [FEATURE_FLAG_TYPES.ACCOUNT_AUTOMATION_ENABLED]: true,
  [FEATURE_FLAG_TYPES.ACCOUNT_CREATED_JOURNEY_ENABLED]: true,
  [FEATURE_FLAG_TYPES.ADMIN_API_AUTH0_ENABLED]: true,
  [FEATURE_FLAG_TYPES.ADMIN_API_AUTO_SYNC_CONDITIONS_ENABLED]: true,
  [FEATURE_FLAG_TYPES.ADMIN_API_QUEUE]: true,
  [FEATURE_FLAG_TYPES.AI_DOCUMENT_EXTRACT_FETCH_SERVICES]: [],
  [FEATURE_FLAG_TYPES.AI_SCHEDULED_PRICING_ELIGIBILITY]: false,
  [FEATURE_FLAG_TYPES.ALFIE_CERTIFIED_CREDIT_PULL]: true,
  [FEATURE_FLAG_TYPES.ALFIE_CREATE_ACCOUNT_SAVE_FIX_ENABLED]: true,
  [FEATURE_FLAG_TYPES.AMC_APPRAISAL_ENABLED]: false,
  [FEATURE_FLAG_TYPES.ANNALY_PAYOFF_ROUTING_ENABLED]: true,
  [FEATURE_FLAG_TYPES.API_QUEUE]: true,
  [FEATURE_FLAG_TYPES.APPLICATION_REVISION_SAVE_LOCK_ENABLED]: false,
  [FEATURE_FLAG_TYPES.APPRAISAL_VALUE_SLACK_NOTIFICATION_ENABLED]: true,
  [FEATURE_FLAG_TYPES.APPS_FETCH_SERVICES]: [],
  [FEATURE_FLAG_TYPES.ASSIGN_LO]: true,
  [FEATURE_FLAG_TYPES.ATTACHMENT_SERVICE_ENCOMPASS_AUTO_SYNC_ENABLED]: true,
  [FEATURE_FLAG_TYPES.AUS_OPEN_AI_ERROR_PROCESSING]: true,
  [FEATURE_FLAG_TYPES.AUS_RECONCILIATION_ENCOMPASS_REMOVAL_ENABLED]: false,
  [FEATURE_FLAG_TYPES.AUS_WATERFALL_ENABLED]: false,
  [FEATURE_FLAG_TYPES.AUTH0_FETCH_SERVICES]: [],
  [FEATURE_FLAG_TYPES.AUTH0_WEBHOOK_PROCESSOR_LAMBDA_ENABLED]: true,
  [FEATURE_FLAG_TYPES.AUTH0_WEBHOOK_PROCESSOR_LOGGING_ENABLED]: true,
  [FEATURE_FLAG_TYPES.AUTH_RECHECK_ON_PAGE_TRANSITION_ENABLED]: false,
  [FEATURE_FLAG_TYPES.AUTO_ASSIGN_INBOUND_CALLS_LOS]: ['ALL'],
  [FEATURE_FLAG_TYPES.AUTO_ASSIGN_LOAN_OFFICER_ENABLED]: true,
  [FEATURE_FLAG_TYPES.AUTO_CONDITION_LINK_ENABLED]: false,
  [FEATURE_FLAG_TYPES.AUTO_CONFIRM_LOCK_REQUEST_ENABLED]: true,
  [FEATURE_FLAG_TYPES.AUTO_PROMOTE_FOR_ALL_LOANS]: false,
  [FEATURE_FLAG_TYPES.AUTO_CONFIRM_COC_LOCK_REQUEST_ENABLED]: false,
  [FEATURE_FLAG_TYPES.AUTO_ICE_BOX_LAMBDA_ENABLED]: false,
  [FEATURE_FLAG_TYPES.AUTO_SYNC_CONDITIONS_ENABLED]: true,
  [FEATURE_FLAG_TYPES.AUTO_TRIGGER_VEPA_VALIDATIONS]: true,
  [FEATURE_FLAG_TYPES.AUTOCONTACT_QUEUE_LAMBDA_ENABLED]: true,
  [FEATURE_FLAG_TYPES.AUTOCONTACT_QUEUE_LOGGING_ENABLED]: true,
  [FEATURE_FLAG_TYPES.AUTOMATED_FOLLOWUP_TEXT_MESSAGES]: true,
  [FEATURE_FLAG_TYPES.AUTOMATED_TEXT_MESSAGES_SKIP_TIME_ZONE_CHECK]: false,
  [FEATURE_FLAG_TYPES.BOOMERANG_EXCLUDED_LOS]: [],
  [FEATURE_FLAG_TYPES.BOTSPLASH_ENABLED]: false,
  [FEATURE_FLAG_TYPES.BOTSPLASH_STRICT_AGENT_VALIDATION]: false,
  [FEATURE_FLAG_TYPES.BOTSPLASH_SHARED_VISITORS_START_AT]: '',
  [FEATURE_FLAG_TYPES.BOTSPLASH_ROUTING_MODE]: 'legacy',
  [FEATURE_FLAG_TYPES.BOTSPLASH_CANARY_PHONES]: '[]',
  [FEATURE_FLAG_TYPES.BOTSPLASH_PROVISIONING_PAUSED]: false,
  [FEATURE_FLAG_TYPES.BOTSPLASH_LISTENER_DIRECTORY_AGENT_LOS]: [],
  [FEATURE_FLAG_TYPES.BOTSPLASH_SMS_INGESTION_ENABLED]: false,
  [FEATURE_FLAG_TYPES.BP_ITERABLE_V1]: true,
  [FEATURE_FLAG_TYPES.BUILDER_LOAN_TEMPLATE_ENABLED]: false,
  [FEATURE_FLAG_TYPES.CALL_TRANSCRIPTION_BACKFILL_ENABLED]: true,
  [FEATURE_FLAG_TYPES.CIC_SLACK_NOTIFICATION_ENABLED]: true,
  [FEATURE_FLAG_TYPES.COMMUNICATION_LOG_RESOLVER_BYPASSED]: false,
  [FEATURE_FLAG_TYPES.CONDITION_NOTIFICATION_ENABLED]: true,
  [FEATURE_FLAG_TYPES.CREATE_VEPA_LETTER_REVISION]: true,
  [FEATURE_FLAG_TYPES.DATA_EXPLORER_SCHEDULE_SLACK_NOTIFY_ENABLED]: false,
  [FEATURE_FLAG_TYPES.DATA_EXPLORER_SHARE_TO_SLACK_ENABLED]: false,
  [FEATURE_FLAG_TYPES.DEBUG_MQ_REQUEST]: false,
  [FEATURE_FLAG_TYPES.DEBUG_NTL_QUALIFICATION]: true,
  [FEATURE_FLAG_TYPES.DEFAULT_QUESTIONNAIRE_SLUG_PURCHASE]:
    'pre-pricing-purchase',
  [FEATURE_FLAG_TYPES.DEFAULT_QUESTIONNAIRE_SLUG]: 'pre-pricing-refinance',
  [FEATURE_FLAG_TYPES.DISABLE_LENDER_CREDIT_FEE]: false,
  [FEATURE_FLAG_TYPES.DOCUMENT_PIPELINE_CONCURRENCY_CAP_ENABLED]: false,
  [FEATURE_FLAG_TYPES.DOCUMENT_PIPELINE_FETCH_SERVICES]: [],
  [FEATURE_FLAG_TYPES.DOCUMENT_UPLOAD_FETCH_SERVICES]: [],
  [FEATURE_FLAG_TYPES.DOCUMENT_CLASSIFICATION_ENABLED]: true,
  [FEATURE_FLAG_TYPES.DOCUMENT_CATEGORIZATION_ENABLED]: true,
  [FEATURE_FLAG_TYPES.DOCUMENT_CONDITION_MATCH_PRE_FILTER_ENABLED]: false,
  [FEATURE_FLAG_TYPES.ENABLE_UNASSIGNED_ATTACHMENT_CONDITION_MATCHING]: false,
  [FEATURE_FLAG_TYPES.DOCUMENT_NAMING_SHADOW_ENABLED]: false,
  [FEATURE_FLAG_TYPES.DOCUMENT_WORKSTATION_PDF_SPLIT_ENABLED]: false,
  [FEATURE_FLAG_TYPES.DOCUSIGN_FETCH_SERVICES]: [],
  [FEATURE_FLAG_TYPES.DOCUTECH_DISCLOSURE_EMAILS_ENABLED]: false,
  [FEATURE_FLAG_TYPES.DOCUTECH_WEBHOOK_PROCESSOR_LAMBDA_ENABLED]: false,
  [FEATURE_FLAG_TYPES.DYNAMIC_PHONE_PILL_ENABLED]: false,
  [FEATURE_FLAG_TYPES.ELLO_BLOCK_UPDATE_ENABLED]: false,
  [FEATURE_FLAG_TYPES.ELLO_SYNC_CREATE_LOAN_ENABLED]: true,
  [FEATURE_FLAG_TYPES.ELLO_SYNC_ENCOMPASS_PUSH_TO_PIPELINE]: true,
  [FEATURE_FLAG_TYPES.ELLO_SYNC_LOAN_ENABLED]: true,
  [FEATURE_FLAG_TYPES.ELLO_SYNC_LOGGING_ENABLED]: true,
  [FEATURE_FLAG_TYPES.ELLO_SYNC_PROCESSOR_LAMBDA_ENABLED]: true,
  [FEATURE_FLAG_TYPES.ELLO_SYNC_SEND_LOAN_AUDIT_SLACK_ENABLED]: true,
  [FEATURE_FLAG_TYPES.ELLO_SYNC_UPDATE_NEW_NOTES]: true,
  [FEATURE_FLAG_TYPES.EMAIL_BACKFILL_DB_DEDUPE_LOGGING_ENABLED]: true,
  [FEATURE_FLAG_TYPES.EMAIL_LOGGING_ENABLED]: true,
  [FEATURE_FLAG_TYPES.EMAIL_PROCESSOR_LAMBDA_ENABLED]: true,
  [FEATURE_FLAG_TYPES.EMAIL_VALIDATOR_LAMBDA_ENABLED]: true,
  [FEATURE_FLAG_TYPES.EMAIL_VALIDATOR_LOGGING_ENABLED]: true,
  [FEATURE_FLAG_TYPES.ENABLE_AI_CALL_NOTES]: true,
  [FEATURE_FLAG_TYPES.ENABLE_AI_CALL_SCORING]: true,
  [FEATURE_FLAG_TYPES.ENABLE_CALL_OPPORTUNITY_EVALUATION]: false,
  [FEATURE_FLAG_TYPES.ENABLE_AI_CALLBACK_SCHEDULE]: true,
  [FEATURE_FLAG_TYPES.ENABLE_AI_CALL_SCHEDULER_LANGFUSE_TRACING]: false,
  [FEATURE_FLAG_TYPES.ENABLE_AI_CONDITION_CLEARING]: false,
  [FEATURE_FLAG_TYPES.ENABLE_ALFIE_CREDIT_ORDER]: false,
  [FEATURE_FLAG_TYPES.ENABLE_ALFIE_PROCESS_LIABILITIES_AND_CREDIT]: true,
  [FEATURE_FLAG_TYPES.ENABLE_APPLICATION_STATUS_DEDUPE]: false,
  [FEATURE_FLAG_TYPES.ENABLE_AUS_ANALYSIS]: true,
  [FEATURE_FLAG_TYPES.ENABLE_ENCOMPASS_FINDINGS_AUS_REPORT_JOB]: false,
  [FEATURE_FLAG_TYPES.ENABLE_AUS_TABLE]: true,
  [FEATURE_FLAG_TYPES.ENABLE_AUTO_CONDITION_REVIEW]: false,
  [FEATURE_FLAG_TYPES.ENABLE_BP_APPLICATION_SWITCHER]: true,
  [FEATURE_FLAG_TYPES.ENABLE_BP_NEWSFEED_REALTOR_QUESTION]: true,
  [FEATURE_FLAG_TYPES.ENABLE_BP_OVERVIEW_PAGE]: true,
  [FEATURE_FLAG_TYPES.ENABLE_BP_PAYMENT_SERVICER_WIDGET]: true,
  [FEATURE_FLAG_TYPES.ENABLE_BP_RATES_PAGE]: false,
  [FEATURE_FLAG_TYPES.ENABLE_BP_RATES_ESTIMATE_DOWNLOAD]: false,
  [FEATURE_FLAG_TYPES.BP_RATES_PAGE_ALLOWLIST]: [],
  [FEATURE_FLAG_TYPES.ENABLE_BP_REALTOR_SEND_EMAIL]: true,
  [FEATURE_FLAG_TYPES.ENABLE_BP_REGGORA_PAGE]: true,
  [FEATURE_FLAG_TYPES.ENABLE_BP_DOCUTECH_IFRAME]: false,
  [FEATURE_FLAG_TYPES.ENABLE_BP_DOC_UPLOAD_FEEDBACK]: false,
  [FEATURE_FLAG_TYPES.ENABLE_BROAD_BP_DOC_UPLOAD_FEEDBACK]: false,
  [FEATURE_FLAG_TYPES.ENABLE_BP_TASKS_V2]: false,
  [FEATURE_FLAG_TYPES.ENABLE_BP_HELOC_CTA]: false,
  [FEATURE_FLAG_TYPES.ENABLE_BP_SIGNED_DISCLOSURE_PACKETS]: false,
  [FEATURE_FLAG_TYPES.ENABLE_CERTIFIED_CREDIT_DEBUG_LOGGING]: true,
  [FEATURE_FLAG_TYPES.ENABLE_COC_MODIFICATIONS]: false,
  [FEATURE_FLAG_TYPES.ENABLE_COC_LOCK_REQUEST_AI_SUMMARY]: false,
  [FEATURE_FLAG_TYPES.ENABLE_CONDITION_FULFILLMENT_CHECK]: true,
  [FEATURE_FLAG_TYPES.ENABLE_CONDITION_FULFILLMENT_SWEEP]: false,
  [FEATURE_FLAG_TYPES.ENABLE_SEMANTIC_SELECTION_IN_CONDITION_FULFILLMENT]: false,
  [FEATURE_FLAG_TYPES.ENABLE_GUIDELINES_CONTEXT_PROVIDER]: false,
  [FEATURE_FLAG_TYPES.ENABLE_DOCS_UPLOADED_STATUS]: false,
  [FEATURE_FLAG_TYPES.ENABLE_CREDIT_REPORT_MERGE_LIABILITIES]: true,
  [FEATURE_FLAG_TYPES.ENABLE_CREDIT_REPORT_VGS_ACCOUNT_ALIAS]: true,
  [FEATURE_FLAG_TYPES.ENABLE_DIRECT_ENCOMPASS_LOCK_REQUEST]: true,
  [FEATURE_FLAG_TYPES.ENABLE_DOCUMENT_CONTENT_SEARCH]: true,
  [FEATURE_FLAG_TYPES.ENABLE_DOCUMENT_STREAM_UPLOADS]: false,
  [FEATURE_FLAG_TYPES.ENABLE_DOCUMENT_SCANNING]: true,
  [FEATURE_FLAG_TYPES.ENABLE_DU_PLUS_ELLO_MODAL]: true,
  [FEATURE_FLAG_TYPES.ENABLE_DU_UPDATED_PDF]: false,
  [FEATURE_FLAG_TYPES.ENABLE_DUPLICATION_SERVICE_LOAN_OFFICER_ASSIGNMENT]: true,
  [FEATURE_FLAG_TYPES.ENABLE_EARLY_CHECK_JOBS]: false,
  [FEATURE_FLAG_TYPES.ENABLE_ENCOMPASS_COMPLIANCE_REVIEW]: false,
  [FEATURE_FLAG_TYPES.ENABLE_ENCOMPASS_PRICING_EXCEPTION]: false,
  [FEATURE_FLAG_TYPES.ENABLE_ENCOMPASS_UPDATE_LOAN_OBJECT]: false,
  [FEATURE_FLAG_TYPES.ENABLE_FANNIE_MAE_DIRECT_PRODUCTION_CREDENTIALS]: false,
  [FEATURE_FLAG_TYPES.ENABLE_FANNIE_TITLE_ACCEPTANCE]: true,
  [FEATURE_FLAG_TYPES.ENABLE_FIGURE_STATUS_CHANGE_DMS]: false,
  [FEATURE_FLAG_TYPES.ENABLE_FILL_MUTATION_LOAN_PURPOSE_DEFAULT]: true,
  [FEATURE_FLAG_TYPES.ENABLE_FLOAT_LOCK_REQUEST_AI_ERRORS]: true,
  [FEATURE_FLAG_TYPES.ENABLE_ITERABLE_WEBHOOK_LOGGING]: false,
  [FEATURE_FLAG_TYPES.ENABLE_LANGFUSE_TRACING]: true,
  [FEATURE_FLAG_TYPES.ENABLE_PLAID_AI_INCOME_ANALYSIS]: false,
  [FEATURE_FLAG_TYPES.ENABLE_PLAID_CRA]: false,
  [FEATURE_FLAG_TYPES.ENABLE_LEAD_ASSIGNMENT_TIMEZONE_CHECK]: true,
  [FEATURE_FLAG_TYPES.ENABLE_LEAD_ROUTING_TIMEZONE_CHECK]: true,
  [FEATURE_FLAG_TYPES.ENABLE_LO_HEADSHOT_UPLOAD]: true,
  [FEATURE_FLAG_TYPES.ENABLE_LO_BORROWER_VIEW]: true,
  [FEATURE_FLAG_TYPES.ENABLE_LO_SSN_UPLOAD_NOTIFICATION]: false,
  [FEATURE_FLAG_TYPES.ENABLE_LO_TRID_TRIPPED_NOTIFICATION]: true,
  [FEATURE_FLAG_TYPES.ENABLE_LOAN_MATCH_REFI_OFFER_EVENT]: true,
  [FEATURE_FLAG_TYPES.ENABLE_LOANCARE_DATA_MATCH_ROUTING]: false,
  [FEATURE_FLAG_TYPES.ENABLE_LOCK_REQUEST_COMMITTING]: false,
  [FEATURE_FLAG_TYPES.ENABLE_LOCK_REQUEST_PRICING_API]: true,
  [FEATURE_FLAG_TYPES.ENABLE_LOCK_REQUEST_SELL_SIDE_UPDATING]: false,
  [FEATURE_FLAG_TYPES.ENABLE_MILITARY_FIELD_SYNC]: true,
  [FEATURE_FLAG_TYPES.ENABLE_AUTO_CONDITION_PROMOTION]: false,
  [FEATURE_FLAG_TYPES.ENABLE_BROAD_AUS_AUTO_CONDITIONING]: false,
  [FEATURE_FLAG_TYPES.ENABLE_AUS_BATCH_ENCOMPASS_SYNC]: false,
  [FEATURE_FLAG_TYPES.ENABLE_MQ_SPECIAL_RATES_FILTERING]: true,
  [FEATURE_FLAG_TYPES.ENABLE_PROCESSOR_TOP_CARDS]: true,
  [FEATURE_FLAG_TYPES.ENABLE_PROCESSOR_PIPELINE_ACTION_REQUIRED]: false,
  [FEATURE_FLAG_TYPES.ENABLE_PURCHASE_LEAD_ASSIGNMENT]: true,
  [FEATURE_FLAG_TYPES.ENABLE_REAPP_CONDITIONS_DUPLICATION]: true,
  [FEATURE_FLAG_TYPES.ENABLE_REAPP_DECS_DEMS_TASK]: false,
  [FEATURE_FLAG_TYPES.ENABLE_REFI_PRICING_GATE]: false,
  [FEATURE_FLAG_TYPES.ENABLE_REFINANCE_LEAD_ASSIGNMENT]: true,
  [FEATURE_FLAG_TYPES.ENABLE_REGGORA_APPRAISAL_ORDER_EMAIL]: false,
  [FEATURE_FLAG_TYPES.ENABLE_REGGORA_PROPERTY_INSPECTION_WAIVER_CHECK]: false,
  [FEATURE_FLAG_TYPES.RH_CONCIERGE_ENABLED_UUIDS]: [],
  [FEATURE_FLAG_TYPES.RH_LEADS_PROD_TO_QA_ROUTING_UUIDS]: [],
  [FEATURE_FLAG_TYPES.RH_HELOC_FIGURE_DEEPLINK_ENABLED]: false,
  [FEATURE_FLAG_TYPES.ENABLE_RH_LEADS_LOGGING]: false,
  [FEATURE_FLAG_TYPES.ENABLE_RINGCENTRAL_WEBHOOK_CONTACT_LOGGING]: true,
  [FEATURE_FLAG_TYPES.ENABLE_ROBINHOOD_NOTIFICATION_EVENT]: false,
  [FEATURE_FLAG_TYPES.ENABLE_SEND_LEADS_SQUEEZE]: true,
  [FEATURE_FLAG_TYPES.ENABLE_SENDGRID_WEBHOOK_LOGGING]: false,
  [FEATURE_FLAG_TYPES.ENABLE_SERVICER_DATA_IMPORT]: true,
  [FEATURE_FLAG_TYPES.ENABLE_SERVICING_LOAN_MATCH_REFI_OFFER_EVENT]: true,
  [FEATURE_FLAG_TYPES.ENABLE_SIMPLE_V1]: true,
  [FEATURE_FLAG_TYPES.ENABLE_BANKRATE_SIMPLE_V2_ROUTING]: false,
  [FEATURE_FLAG_TYPES.ENABLE_SIMPLE_V2_PILOT_ASSIGNMENT]: false,
  [FEATURE_FLAG_TYPES.ENABLE_SIMPLE_V2_FANNIE_VARIANT]: false,
  [FEATURE_FLAG_TYPES.ENABLE_SIMPLE_V2_ASSIGN_AT_INTAKE]: false,
  [FEATURE_FLAG_TYPES.ENABLE_SPECIAL_ALFIE_LINK_HANDLING]: false,
  [FEATURE_FLAG_TYPES.ENABLE_STORYBLOK_FOLDERS]: false,
  [FEATURE_FLAG_TYPES.ENABLE_TRANSUNION_DEBUG_LOGGING]: false,
  [FEATURE_FLAG_TYPES.ENABLE_TU_MORTGAGE_RATE_ESTIMATES]: true,
  [FEATURE_FLAG_TYPES.ENABLE_UPDATE_TRACKING_DATA]: true,
  [FEATURE_FLAG_TYPES.ENABLE_UW_HANDOFF_GENERATION]: true,
  [FEATURE_FLAG_TYPES.ENABLE_VEPA_AUTO_SSN_TASK]: false,
  [FEATURE_FLAG_TYPES.ENABLE_VEPA_AUTO_SOFT_PULL_ON_SSN]: false,
  [FEATURE_FLAG_TYPES.ENABLED_EVENTING_EVENTS]: {
    loanClearToClose: true,
    underwriting: true,
    lenderLocked: true,
    lockedRate: true,
    externalLeadConverted: true,
    loAssignment: true,
    loanEsigned: true,
    applicationStarted: true,
    appAbandon: true,
    loanFunded: true,
    loanLocked: true,
    loanConditionallyApproved: true,
    prequalRevisionCheck: true,
    accountCreated: true,
    applicationRevised: true,
    makePrequalRevision: true,
    processorAssignment: true,
  },
  [FEATURE_FLAG_TYPES.ENCOMPASS_ATTACHMENT_DOWNLOAD_ENABLED]: false,
  [FEATURE_FLAG_TYPES.ENCOMPASS_ATTACHMENT_LINK_ENABLED]: true,
  [FEATURE_FLAG_TYPES.ENCOMPASS_ATTACHMENT_RECONCILIATION_ENABLED]: false,
  [FEATURE_FLAG_TYPES.ENCOMPASS_AUTO_CREATE_PRELIM_CONDITION_ON_DOCUMENT_SYNC_ENABLED]: false,
  [FEATURE_FLAG_TYPES.ENCOMPASS_AUTO_LOCK_REQUEST_ENABLED]: true,
  [FEATURE_FLAG_TYPES.ENCOMPASS_CONDITION_REMOVAL_CORRECTION_ENABLED]: false,
  [FEATURE_FLAG_TYPES.ENCOMPASS_CONDITION_SYNC_ENABLED]: false,
  [FEATURE_FLAG_TYPES.ENCOMPASS_CONDITION_SYNC_HACK_ENABLED]: false,
  [FEATURE_FLAG_TYPES.ENCOMPASS_DISCLOSURE_TASKS_ENABLED]: true,
  [FEATURE_FLAG_TYPES.ENCOMPASS_ENABLE_PROCESSOR_SYNC]: false,
  [FEATURE_FLAG_TYPES.ENCOMPASS_FETCH_SERVICES]: [],
  [FEATURE_FLAG_TYPES.ENCOMPASS_MILESTONE_COMMENT_SYNC_ENABLED]: true,
  [FEATURE_FLAG_TYPES.ENCOMPASS_PENDING_SYNC_PROTECTION_ENABLED]: false,
  [FEATURE_FLAG_TYPES.ENCOMPASS_REMOVAL_VERIFICATION_ENABLED]: false,
  [FEATURE_FLAG_TYPES.ENCOMPASS_PRICING_INPUTS_ENABLED]: true,
  [FEATURE_FLAG_TYPES.ENCOMPASS_PRICING_SCENARIO_FEES_IN_UPDATE_ENABLED]: false,
  [FEATURE_FLAG_TYPES.ENCOMPASS_REPORTING_RESYNC_MAX_RECORD_COUNT]: 2000,
  [FEATURE_FLAG_TYPES.ENCOMPASS_RESOURCE_LOCK_BLOCK_VEPA_UPDATES]: false,
  [FEATURE_FLAG_TYPES.ENCOMPASS_RESOURCE_LOCK_PLUGIN_ENABLED]: true,
  [FEATURE_FLAG_TYPES.ENCOMPASS_SDK_ENABLED]: false,
  [FEATURE_FLAG_TYPES.ENCOMPASS_TEMPLATE_FOLDERS_ENABLED]: true,
  [FEATURE_FLAG_TYPES.ENCOMPASS_TEMPLATE_UPDATE_ENABLED]: true,
  [FEATURE_FLAG_TYPES.ENCOMPASS_UNDERWRITING_CONDITION_SYNC_ENABLED]: true,
  [FEATURE_FLAG_TYPES.ENCOMPASS_UNDERWRITING_CONDITION_SYNC_INTERNAL]: true,
  [FEATURE_FLAG_TYPES.ENCOMPASS_WEBHOOK_LOGGING_ENABLED]: true,
  [FEATURE_FLAG_TYPES.ENCOMPASS_WEBHOOK_PROCESSOR_LAMBDA_ENABLED]: true,
  [FEATURE_FLAG_TYPES.ENHANCED_AUTO_TEXT_TIMING]: true,
  [FEATURE_FLAG_TYPES.ESSENT_QUOTING_ENABLED]: true,
  [FEATURE_FLAG_TYPES.EVENT_MODEL_LOGGING_ENABLED]: true,
  [FEATURE_FLAG_TYPES.EVENT_MODEL_PROCESSOR_LAMBDA_ENABLED]: true,
  [FEATURE_FLAG_TYPES.EXPOSE_MORTGAGE_RATE_ESTIMATES]: true,
  [FEATURE_FLAG_TYPES.EXTERNAL_SYNC_TRACKING_ENABLED]: false,
  [FEATURE_FLAG_TYPES.FANNIE_MAE_AUTOMATION_FLOW_ROLLOUT_PERCENTAGE]: 1.1,
  [FEATURE_FLAG_TYPES.FANNIE_MAE_AUTOMATION_PILOT_FORCE_CO_DEV_ENVIRONMENT]: false,
  [FEATURE_FLAG_TYPES.FANNIE_MAE_CREDIT_REPORT_PARSING]: true,
  [FEATURE_FLAG_TYPES.FANNIE_MAE_DIRECT_AUS]: true,
  [FEATURE_FLAG_TYPES.FANNIE_MAE_DIRECT_CREDIT_REPORT_REQUEST_TYPE]: 'hard',
  [FEATURE_FLAG_TYPES.FANNIE_MAE_DIRECT_FAILURE_DIAGNOSTICS]: false,
  [FEATURE_FLAG_TYPES.FANNIE_MAE_DIRECT_JSON_RESPONSE]: false,
  [FEATURE_FLAG_TYPES.FANNIE_MAE_DIRECT_LOGGING]: true,
  [FEATURE_FLAG_TYPES.FANNIE_MAE_DIRECT_TESTING_TABLES]: true,
  [FEATURE_FLAG_TYPES.FANNIE_MAE_DIRECT_VA_PD_CONTACT]: true,
  [FEATURE_FLAG_TYPES.FANNIE_MAE_FETCH_SERVICES]: [],
  [FEATURE_FLAG_TYPES.FANNIE_MAE_PLAID_ENABLED]: false,
  [FEATURE_FLAG_TYPES.FANNIE_MAE_SOFT_CREDIT_PULL]: false,
  [FEATURE_FLAG_TYPES.FANNIE_MAE_SOFT_CREDIT_PULL_ALLOWLIST]: [],
  [FEATURE_FLAG_TYPES.FANNIE_MAE_TEST_CREDIT_SERVICE]: false,
  [FEATURE_FLAG_TYPES.FINICITY_FETCH_SERVICES]: [],
  [FEATURE_FLAG_TYPES.FIVE9_FETCH_SERVICES]: [],
  [FEATURE_FLAG_TYPES.FIVE9_SMS_ENABLED]: false,
  [FEATURE_FLAG_TYPES.FIVE9_CONTACTS_ENABLED]: false,
  [FEATURE_FLAG_TYPES.GEMINI_FULFILLMENT_ENABLED]: false,
  [FEATURE_FLAG_TYPES.GENERATE_PRELIMINARY_CONDITIONS]: true,
  [FEATURE_FLAG_TYPES.GEMINI_OCR_ENABLED]: false,
  [FEATURE_FLAG_TYPES.HOME_EQUITY_FETCH_SERVICES]: [],
  [FEATURE_FLAG_TYPES.HOME_EQUITY_IGNORE_EXISTING_USER_EMAIL]: true,
  [FEATURE_FLAG_TYPES.HOME_EQUITY_NO_OFFER_REASONS]: false,
  [FEATURE_FLAG_TYPES.HOME_EQUITY_SKIP_EXISTING_ASSIGNMENT_CHECK]: true,
  [FEATURE_FLAG_TYPES.HOME_EQUITY_SKIP_FIGURE_NON_RH]: false,
  [FEATURE_FLAG_TYPES.ICE_ENABLED_STATES]: [],
  [FEATURE_FLAG_TYPES.LAMBDAS_FETCH_SERVICES]: [],
  [FEATURE_FLAG_TYPES.LEAD_ASSIGNMENT_DIRECT_MESSAGE]: true,
  [FEATURE_FLAG_TYPES.LEAD_ROUTING_CHECK_ACTIVE_CALLS]: false,
  [FEATURE_FLAG_TYPES.LEAD_ROUTING_CHECK_ASSIGNMENT_LIMIT]: true,
  [FEATURE_FLAG_TYPES.LEAD_ROUTING_CHECK_CLOCKED_IN]: true,
  [FEATURE_FLAG_TYPES.LEAD_ROUTING_DISABLED_SOURCES]: [],
  [FEATURE_FLAG_TYPES.LEAD_ROUTING_GROUP_QUEUE_DELAY_SECONDS]: 0,
  [FEATURE_FLAG_TYPES.LEAD_ROUTING_GROUP_QUEUE_ENABLED]: true,
  [FEATURE_FLAG_TYPES.LEAD_ROUTING_GROUP_QUEUE_ORDER]: 'ladyandthetramp',
  [FEATURE_FLAG_TYPES.LEAD_ROUTING_HARD_ASSIGNMENT_LIMIT_CHECK]: true,
  [FEATURE_FLAG_TYPES.LEAD_ROUTING_HARD_IS_PURCHASE_CHECK]: true,
  [FEATURE_FLAG_TYPES.LEAD_ROUTING_HARD_IS_REFINANCE_CHECK]: true,
  [FEATURE_FLAG_TYPES.LEAD_ROUTING_LOGGING_ENABLED]: true,
  [FEATURE_FLAG_TYPES.LEAD_ROUTING_PROCESSOR_LAMBDA_MODE]: 'run',
  [FEATURE_FLAG_TYPES.LEAD_ROUTING_RECIRCULATION_MAX_SIGNAL]: 'dial_2',
  [FEATURE_FLAG_TYPES.LEAD_ROUTING_RECIRCULATION_MODE]: 'off',
  [FEATURE_FLAG_TYPES.LEAD_ROUTING_RECIRCULATION_SOURCES]: [],
  [FEATURE_FLAG_TYPES.LEAD_ROUTING_QUEUE_ENABLED_HOME_EQUITY]: false,
  [FEATURE_FLAG_TYPES.LEAD_ROUTING_HOME_EQUITY_SQUEEZE_FALLBACK_ENABLED]: false,
  [FEATURE_FLAG_TYPES.LEAD_SCORING_PREDICTION_CACHE_ENABLED]: false,
  [FEATURE_FLAG_TYPES.LEAD_SCORING_QUEUE_SCORING_ENABLED]: false,
  [FEATURE_FLAG_TYPES.LEAD_SCORING_RESCORE_JOB_ENABLED]: false,
  [FEATURE_FLAG_TYPES.LEAD_SCORING_ROBINHOOD_ROUTING_ENABLED]: false,
  [FEATURE_FLAG_TYPES.LEAD_SCORING_ROUTING_ENABLED]: true,
  [FEATURE_FLAG_TYPES.LEAD_SCORING_ROUTING_PERCENT]: 0,
  [FEATURE_FLAG_TYPES.LEAD_SCORING_SCORE_ALL_POLICIES_ENABLED]: false,
  [FEATURE_FLAG_TYPES.LENDER_ENABLED_LOS]: [],
  [FEATURE_FLAG_TYPES.LENDER_ENABLED_STATES]: [],
  [FEATURE_FLAG_TYPES.LO_ASSIGNMENT_USE_WEEKLY_COUNT]: false,
  [FEATURE_FLAG_TYPES.LO_LENDER_LICENSE_ENABLED]: false,
  [FEATURE_FLAG_TYPES.LOAN_ASSISTANT_CHAT_FETCH_SERVICES]: [],
  [FEATURE_FLAG_TYPES.LOAN_MATCH_SILK_FEES_ENABLED]: false,
  [FEATURE_FLAG_TYPES.LOAN_OFFICER_APPLICATION_REMINDER_REMINDERS_ENABLED]: true,
  [FEATURE_FLAG_TYPES.LOAN_OFFICER_REMINDERS_ENABLED]: true,
  [FEATURE_FLAG_TYPES.LOAN_OFFICER_REMINDERS_EXCLUDED_USERNAMES]: [
    'lsoderberg',
    'dbeumer',
  ],
  [FEATURE_FLAG_TYPES.LOAN_PROGRAM_RULES_ENABLED]: true,
  [FEATURE_FLAG_TYPES.LOG_FEE_REQUEST_ENABLED]: false,
  [FEATURE_FLAG_TYPES.NEW_ZIP_LEAD_PUSH_ENABLED]: false,
  [FEATURE_FLAG_TYPES.NTL_DISABLED_QUESTION_SETS]: [
    'pre-pricing-refinance',
    'ntl',
  ],
  [FEATURE_FLAG_TYPES.PARTNER_API_REDIRECT_URL_ALLOWLIST]: [],
  [FEATURE_FLAG_TYPES.PARTNERS_FETCH_SERVICES]: [],
  [FEATURE_FLAG_TYPES.PASSWORDLESS_WORKFLOW]: true,
  [FEATURE_FLAG_TYPES.PATRICK_APPROVAL_SLACK_NOTIFY_ENABLED]: false,
  [FEATURE_FLAG_TYPES.PATRICK_BROWSER_REPLAY_ENABLED]: false,
  [FEATURE_FLAG_TYPES.PATRICK_RUN_SLACK_NOTIFY_ENABLED]: false,
  [FEATURE_FLAG_TYPES.PATRICK_SCHEDULES_ENABLED]: false,
  [FEATURE_FLAG_TYPES.PATRICK_TRIGGERS_ENABLED]: false,
  [FEATURE_FLAG_TYPES.PATRICK_WORKSPACE_ATHENA_ONLY_ENABLED]: false,
  [FEATURE_FLAG_TYPES.PHOENIX_ONLY_ENABLED]: false,
  [FEATURE_FLAG_TYPES.PHONE_FLOW_ENABLED]: true,
  [FEATURE_FLAG_TYPES.PRELIMINARY_CONDITION_SYNC_ENABLED]: true,
  [FEATURE_FLAG_TYPES.PROCESSOR_CONDITION_UPLOAD_SLACK_V1]: false,
  [FEATURE_FLAG_TYPES.RATE_SHEET_CREATOR_GLOBAL_CONFIG]: false,
  [FEATURE_FLAG_TYPES.RING_CENTRAL_CONTACTS]: true,
  [FEATURE_FLAG_TYPES.RING_CENTRAL_FETCH_SERVICES]: [],
  [FEATURE_FLAG_TYPES.ROBINHOOD_ONLY_ENABLED]: false,
  [FEATURE_FLAG_TYPES.ROUTE_DU_TO_ENCOMPASS_AFTER_REGISTRATION]: false,
  [FEATURE_FLAG_TYPES.S3_NOTIFICATION_PROCESSOR_LAMBDA_ENABLED]: true,
  [FEATURE_FLAG_TYPES.S3_NOTIFICATION_PROCESSOR_LOGGING_ENABLED]: true,
  [FEATURE_FLAG_TYPES.SAGE_CLOSING_CREDIT_OFFER_AMOUNT]: 0,
  [FEATURE_FLAG_TYPES.PATRICK_SLACK_NOTIFICATIONS_ENABLED]: false,
  [FEATURE_FLAG_TYPES.SCHEDULE_SLACK_NOTIFY_ENABLED]: false,
  [FEATURE_FLAG_TYPES.SERVICER_LEAD_DEFER_ROUTING_ENABLED]: false,
  [FEATURE_FLAG_TYPES.SERVICES_FETCH_SERVICES]: [],
  [FEATURE_FLAG_TYPES.SHOW_BORROWER_PORTAL_V2]: true,
  [FEATURE_FLAG_TYPES.SHOW_COVERAGE_NAVIGATION_OPTION]: false,
  [FEATURE_FLAG_TYPES.SHOW_PRICING_STEP_LEFT_RAIL]: true,
  [FEATURE_FLAG_TYPES.SIDEBAR_ENABLED]: true,
  [FEATURE_FLAG_TYPES.SILK_CACHE_ENABLED]: true,
  [FEATURE_FLAG_TYPES.SKIP_AVM_REQUEST]: false,
  [FEATURE_FLAG_TYPES.SKIP_BORROWER_PORTAL]: false,
  [FEATURE_FLAG_TYPES.SNS_APPLICATION_PUBLISH]: true,
  [FEATURE_FLAG_TYPES.SOFT_CREDIT_REPORT_PROVIDER]: 'transunion',
  [FEATURE_FLAG_TYPES.SUSPENSION_NOTIFICATIONS_ENABLED]: true,
  [FEATURE_FLAG_TYPES.TEST_ICE_DEFAULTS]: false,
  [FEATURE_FLAG_TYPES.TESTING_INTERNAL_AUS]: true,
  [FEATURE_FLAG_TYPES.TOGGLE_NEW_DEBT_TO_INCOME_CALCULATION]: true,
  [FEATURE_FLAG_TYPES.TRID_COUNTDOWN_REMINDERS_ENABLED]: true,
  [FEATURE_FLAG_TYPES.TRID_SCHEDULED_ENCOMPASS_PUSH]: true,
  [FEATURE_FLAG_TYPES.UNISOURCE_ENABLED]: true,
  [FEATURE_FLAG_TYPES.UNISOURCE_OVERRIDE]: false,
  [FEATURE_FLAG_TYPES.UPDATE_ENCOMPASS_LOCK_DATA_ENABLED]: false,
  [FEATURE_FLAG_TYPES.UPDATE_ENCOMPASS_MILESTONES]: true,
  [FEATURE_FLAG_TYPES.USE_AMAZON_TRANSCRIBE]: true,
  [FEATURE_FLAG_TYPES.USE_GOOGLE_TIME_ZONE_API]: true,
  [FEATURE_FLAG_TYPES.USE_INTERNAL_APR_CALCULATION]: true,
  [FEATURE_FLAG_TYPES.USE_NEW_MERGE_CREDIT_LIABILITIES_PROCESS]: true,
  [FEATURE_FLAG_TYPES.USE_WORKER_RH_TOKEN_DECRYPTION]: true,
  [FEATURE_FLAG_TYPES.VEPA_ALERT_SHADOW_TEST]: false,
  [FEATURE_FLAG_TYPES.VEPA_NOTIFICATION_ENABLED_LOS]: ['ALL'],
}
